/* eslint-disable-no-else-return */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
import Can, {checkPermission} from '../../common/guards/can';
import Footer from '../../footer';

import {footerLinksForRepLayout} from '../../../data/footerLinks';
import {check as loggedIn, isAdminLoggedIn, isRepLoggedIn} from '../../../utils/tokenUtils';
import {USER_TYPE_REP} from '../../../data/userTypes';

import IgniteNavigation from '../ignite-navigation';
import {ACTION_LOGIN, SUBJECT_TEAM_PORTAL} from '../../../data/subjectClasses';

import './rep-layout.css';

class MainLayout extends Component {
  setScrolling = () => (this.props.viewConfig.lockSroll ? 'noscroll' : '');

  render() {
    if (loggedIn() && !isRepLoggedIn() && !checkPermission('login', 'team_portal')) {
      if (isAdminLoggedIn()) {
        return <Redirect to="/admin"/>;
      }
      return <Redirect to="/"/>;
    }

    const {
      component: RenderComponent, action, subjectClass, private: privateRoute, viewConfig, ...rest
    } = this.props;

    const {setScrolling} = this;

    if (privateRoute && !loggedIn()) {
      return <Redirect to="/team/login"/>;
    }

    return (
      <Route
        {...rest}
        render={matchProps => (
          <Can action={ACTION_LOGIN} subjectClass={SUBJECT_TEAM_PORTAL} cannot={<Redirect to='/team/login'/>}>
            <div className='rep-layout'>
              <div id="top-bg-container" />
              <div id="bottom-bg-container" />
              <Can action={action} subjectClass={subjectClass} cannot={<Redirect to="/team/my-profile"/>}>
                <div className={setScrolling}>
                  <div className='content-wrapper'>

                    <IgniteNavigation type={USER_TYPE_REP} igniteLogoLink={viewConfig.isRep ? '/team' : '/team/my-profile'}/>

                    <RenderComponent {...matchProps} area={USER_TYPE_REP}/>

                    <Footer links={footerLinksForRepLayout}/>
                  </div>
                </div>
              </Can>
            </div>
          </Can>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  viewConfig: state.viewConfig,
});

export default connect(mapStateToProps)(MainLayout);



// WEBPACK FOOTER //
// ./src/components/layout/rep-layout/rep-layout.jsx